const getSiteName = (rootState) => rootState.ws.site.name;

export default getSiteName;
